$('.container_accordion, .container_accordion_thematiques').accordion({
  selector: {
    trigger: '.title'
  }
});
